import { OreButton, OreStack, OreTooltip, SvgArrowLeft } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useContractNewProducts } from '@/Contract/ui/context'
import { productContractingTranslation } from '@/Contract/ui/contractTranslation'
import { Step2Form } from '@/Contract/ui/hooks'

export const ContractNewProductsStep3Actions = (): JSX.Element => {
  const { t } = useTranslation()

  const { handleSubmit } = useFormContext<Step2Form>()
  const {
    saveStep3,
    previousStep,
    documents: { dowloadedDocuments },
  } = useContractNewProducts()

  const signButton = (
    <OreButton
      data-testid="saveStepThree"
      category={'primary'}
      onClick={handleSubmit(saveStep3)}
      disabled={
        !dowloadedDocuments
          .filter(d => d.mustBeSigned === true)
          .every(d => d.signed === true)
      }
    >
      {t(productContractingTranslation.contractProductPage.step3.buttons.next.label)}
    </OreButton>
  )

  return (
    <OreStack space="large" direction="row" placeContent="space-between">
      <OreButton
        data-testid="previous"
        category={'tertiary'}
        icon={<SvgArrowLeft />}
        onClick={previousStep}
      >
        {t(
          productContractingTranslation.contractProductPage.step3.buttons.previous.label,
        )}
      </OreButton>

      {!dowloadedDocuments
        .filter(d => d.mustBeSigned === true)
        .every(d => d.signed === true) ? (
        <OreTooltip
          text={t(
            productContractingTranslation.contractProductPage.step3.buttons.next.disabled,
          )}
          placement="top"
        >
          {signButton}
        </OreTooltip>
      ) : (
        signButton
      )}
    </OreStack>
  )
}
